import type { Website } from "~/types/api/client"
import type { ClientNavigation } from "~/types/api/user"
import type {
    TrustpilotResponseFormat,
    TrustpilotReviewType,
    TrustpilotReviewsListResponse,
    TrustpilotSchemaOrgPayload,
} from "~/types/api/client/trustpilot/reviews"
import { WebsiteAPI } from '~/utils/api/client/website/websiteapi'
import { CompiereAPI } from "./compiere/index"
import { googleAPI } from "./google/google"
import { mailBuilderAPI } from "./mail-builder/mailbuilder"

export class ClientAPI {
    clientId: number
    compiere: CompiereAPI;

    constructor(clientId: number) {
        this.clientId = clientId
        this.compiere = new CompiereAPI(clientId)
    }

    async getWebsites(websiteid?: number): Promise<Website[]> {
        const response = await $fetch<Website[]>(`/api/client/website?clientid=${this.clientId}${websiteid?`&websiteid=${websiteid}`:''}`, {
            headers:useRequestHeaders(['cookie'])
        }).catch(err => {
            switch(err.statusCode) {
                case 401:
                    return {status: 401, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    async getClientNavigation(): Promise<ClientNavigation[]> {
        const response = await $fetch<ClientNavigation[]>(`/api/user/clientnavigation`, {
            headers:useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId
            }
        }).catch(err => {
            switch(err.statusCode) {
                case 401:
                    return {status: 401, message: err.message}
                default:
                    return {status: 0, message: 'No idea man'}
            }
        })
        return response
    }

    website(websiteId: number) {
        return new WebsiteAPI(this.clientId, websiteId);
    }
    
    google(propertyId: number) {
        return new googleAPI(this.clientId, propertyId);
    }

    /**
     * List Trustpilot service or product reviews.
     * Prefer domainId so credentials load from domains.trustpilot.
     * Use format: 'schema' for schema.org JSON-LD.
     */
    async getTrustpilotReviews(options: {
        domainId?: number | string
        businessUnitId?: string
        domain?: string
        type?: TrustpilotReviewType
        format?: TrustpilotResponseFormat
        sku?: string[] | string
        page?: number
        perPage?: number
        stars?: number[] | string
        language?: string
        orderBy?: string
        privateAccess?: boolean
    }): Promise<TrustpilotReviewsListResponse | TrustpilotSchemaOrgPayload> {
        return await $fetch<TrustpilotReviewsListResponse | TrustpilotSchemaOrgPayload>('/api/client/trustpilot/reviews', {
            headers: useRequestHeaders(['cookie']),
            query: {
                clientid: this.clientId,
                domainId: options.domainId,
                businessUnitId: options.businessUnitId,
                domain: options.domain,
                type: options.type,
                format: options.format,
                sku: Array.isArray(options.sku) ? options.sku.join(',') : options.sku,
                page: options.page,
                perPage: options.perPage,
                stars: Array.isArray(options.stars) ? options.stars.join(',') : options.stars,
                language: options.language,
                orderBy: options.orderBy,
                private: options.privateAccess ? 'true' : undefined,
                apikey: '2e2aecd8bc758042c365bc227e300245',
            },
        })
    }

    mailBuilder() {
        return new mailBuilderAPI(this.clientId);
    }

}
